import { Injectable } from '@angular/core';
import { AccessDecisionManager } from './access-decision-manager';
import { CurrentUser } from '../providers/current-user';
import { User } from "../models/user";
import { Organization } from "../models/organization";
import { Voter } from "./voter";

@Injectable({providedIn: 'root'})
export class AuthorizationChecker {
    private accessDecisionManager: AccessDecisionManager;
    private currentUser: CurrentUser;

    constructor(accessDecisionManager: AccessDecisionManager, currentUser: CurrentUser) {
        this.accessDecisionManager = accessDecisionManager;
        this.currentUser = currentUser;
    }

    /**
     * Checks if the attributes are granted against the current user and optionally supplied subject.
     *
     * @param {string|array} attributes
     * @param {Object} subject
     *
     * @return bool
     */
    public isGranted(attributes: any, subject: any = null) {
        if (this.currentUser instanceof User) {
            throw Error('There is no authenticated user !');
        }

        if (!Array.isArray(attributes)) {
            attributes = [attributes];
        }

        return this.accessDecisionManager.decide(this.currentUser, attributes, subject);
    }

    public setOrganization(organization: Organization) {
        this.currentUser['organization'] = organization;
    }

    public denyAccessUnlessGranted(attributes: any, subject: any = null) {
        if (!this.isGranted(attributes, subject)) {
            throw new Error('You are not allowed to access this resource or you missed to call setOrganization on AuthorizationChecker');
        }
    }

    public addVoter(voter:Voter) {
        this.accessDecisionManager.addVoter(voter);
    }
}
